import { NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';

import { BetBuilderPickComponent } from '../../../option-pick/betbuilder-pick.component';
import { BetBuilderMarket } from '../../model/bet-builder.model';
import { BetBuilderEditPrecreatedBABButtonComponent } from '../button/bet-builder-edit-precreated-bab-button.component';

@Component({
    selector: 'ms-bet-builder-market-card',
    templateUrl: './bet-builder-market-card.component.html',
    imports: [NgOptimizedImage, BetBuilderPickComponent, FontResizerComponent, BetBuilderEditPrecreatedBABButtonComponent, NativePriceFormatterPipe],
})
export class BetBuilderMarketCardComponent implements OnInit {
    @Input() event: EventModel;
    @Input() market: BetBuilderMarket;
    @Input() fixtureId: string;
    @Input() showName: boolean;

    marketLegs: string[];
    pickTrackingSource = 'BetBuilder/PreCreated';

    ngOnInit(): void {
        this.marketLegs = this.mapLegs();

        if (this.market.ambassador) {
            this.pickTrackingSource += '/AP';
        }
    }

    private mapLegs(): string[] {
        return this.market.name.split(';');
    }
}
